import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { formatApiError } from "../lib/api";
import { Hospital, SignIn } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setBusy(true);
    try {
      await login(username.trim(), password);
      navigate("/");
    } catch (e2) {
      setErr(formatApiError(e2));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F4F6F8] flex items-center justify-center px-4">
      <div className="w-full max-w-md">
        <div className="bg-white border border-slate-200 rounded shadow-sm p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-11 h-11 rounded bg-[#0A3F9A] text-white flex items-center justify-center">
              <Hospital size={22} weight="duotone" />
            </div>
            <div>
              <div className="text-lg font-bold text-slate-900">
                Kalkulator Biaya Operasi
              </div>
              <div className="text-xs text-slate-500 uppercase tracking-wider">
                Login Tim Admission
              </div>
            </div>
          </div>

          <form onSubmit={submit} className="flex flex-col gap-4" data-testid="login-form">
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-bold uppercase tracking-wide text-slate-600">
                Username
              </label>
              <input
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="admin atau staff"
                className="w-full bg-white border border-slate-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-[#0A3F9A] focus:border-[#0A3F9A]"
                data-testid="input-login-username"
                autoFocus
                required
              />
            </div>
            <div className="flex flex-col gap-1.5">
              <label className="text-xs font-bold uppercase tracking-wide text-slate-600">
                Password
              </label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="********"
                className="w-full bg-white border border-slate-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-[#0A3F9A] focus:border-[#0A3F9A]"
                data-testid="input-login-password"
                required
              />
            </div>
            {err && (
              <div
                className="bg-red-50 border border-red-200 text-red-700 text-sm rounded px-3 py-2"
                data-testid="login-error"
              >
                {err}
              </div>
            )}
            <button
              type="submit"
              disabled={busy}
              className="bg-[#0A3F9A] text-white px-4 py-2.5 rounded hover:bg-[#082F73] text-sm font-medium flex items-center justify-center gap-2 disabled:opacity-60"
              data-testid="btn-login"
            >
              <SignIn size={16} weight="duotone" /> {busy ? "Login..." : "Masuk"}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
